import 'angular/guides/controllers';

const modules = [
    'ui.bootstrap',
    'graphdb.framework.guides.controllers'
];

angular.module('graphdb.framework.guides', modules);
